import { Partner, UsufructData } from 'types';
import { CustomRetention } from 'types/Operation';

type CreateDividendsProps = {
  partners: Partner[];
  societyActualSharesCount: number;
  totalAmount: number;
  generalRetentionPercentage: number;
  customRetentions: CustomRetention[];
  usufructDataByPartner?: { [key: string]: UsufructData[] };
};

export const createDividends = ({
  partners,
  societyActualSharesCount,
  totalAmount,
  generalRetentionPercentage,
  customRetentions,
  usufructDataByPartner = {},
}: CreateDividendsProps) =>
  partners.map((partner) => {
    const usufructData = usufructDataByPartner[partner._id] || [];

    const usufructSharesCount = usufructData.reduce((acc, data) => {
      const sharesCount = (data.sharesCount * data.percentage) / 100 || 0;
      return acc + (data.isMainCoOwner ? -sharesCount : sharesCount);
    }, 0);

    const partnerSharesCount =
      (partner.sharesCount?.actual || 0) + usufructSharesCount;

    const ndPercent =
      ((partner.sharesCount?.actual || 0) / societyActualSharesCount) * 100 ||
      0;

    const ndPercentWithUsufruct =
      ((partnerSharesCount || 0) / societyActualSharesCount) * 100 || 0;

    const dividendAmount = (ndPercentWithUsufruct * totalAmount) / 100 || 0;

    const existingIndex = customRetentions.findIndex(
      (retention) => retention.partner === partner._id
    );

    const retentionPercentage =
      existingIndex !== -1 && existingIndex !== undefined
        ? customRetentions[existingIndex].retentionPercentage
        : generalRetentionPercentage;

    const retentionAmount = (dividendAmount * retentionPercentage) / 100 || 0;

    return {
      partnerId: partner._id,
      partnerName: partner?.name,
      ndPercent,
      dividendAmount,
      retentionAmount,
      usufructData,
    };
  });
